import styled from 'styled-components';

import { shimmerMixin } from 'components/Skeleton';

const LogoPlaceholder = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  object-fit: scale-down;
  object-position: center;
  max-width: 15rem;
  height: auto;
`;

const TitleLine = styled.div<{ width?: string }>`
  height: 2.4rem;
  width: ${({ width }) => width ?? '70%'};
  margin: 0.2rem auto;
  border-radius: 0.2rem;
  ${shimmerMixin}
`;

const CTABlock = styled.div`
  height: 3rem;
  width: 47%;
  border-radius: 0.2rem;
  ${shimmerMixin}
`;

export { CTABlock, LogoPlaceholder, TitleLine };
